<div class="w-full flex flex-col gap-4">
	<div>
		<p class="p-sm max-w-[600px]">
			The Closer team will reach out to the lender on your behalf when you
			submit your Request for Funds to confirm the package's receipt.<br /><br />If
			there are any issues with the details provided in the Request for Funds
			form, the lender will contact you directly.
		</p>
	</div>
	<div class="border rounded-xl">
		<div
			class="grid grid-cols-12 border-b bg-gray-100 items-center rounded-t-xl"
		>
			<div class="col-span-4 p-4 h6">Package</div>
			<div class="col-span-2 p-4 h6">Sent Details</div>
			<div class="col-span-3 p-4 h6 flex items-center gap-0.5">
				Transmission Details
				<i-tabler
					name="info-circle"
					class="text-gray-500 w-4 h-4"
					matTooltip="Date your package was sent to the lender."
				/>
			</div>
			<div class="col-span-3 p-4 h6 flex items-center gap-0.5">
				Status
				<i-tabler
					name="info-circle"
					class="text-gray-500 w-4 h-4"
					matTooltip='Any package with a "Pending Confirmation" status will update to "Received by Lender" once we have made contact with the lender and confirmed receipt.'
				/>
			</div>
		</div>
		<ng-container *ngIf="(packages$ | async)?.length; else noPackages">
			<div
				*ngFor="let package of packages$ | async"
				class="grid grid-cols-12 border-b last:border-none"
			>
				<div class="col-span-4 p-4 space-y-4">
					<ui-anchor (click)="openPDF(package)">{{
						package.packageName
					}}</ui-anchor>
					<ul class="list-inside list-disc space-y-1">
						<li class="p-xs" *ngFor="let file of package.file.mergedFiles">
							{{ file.name }}
						</li>
					</ul>
				</div>
				<div class="col-span-2 p-4 space-y-4">
					<div class="space-y-1">
						<p class="p-xs text-gray-400">Sent From</p>
						<p class="p-sm">{{ package.faxSentFrom }}</p>
					</div>
					<div class="space-y-1">
						<p class="p-xs text-gray-400">Sent To</p>
						<p class="p-sm">{{ package.faxSentTo }}</p>
					</div>
				</div>
				<div class="col-span-3 p-4 flex flex-col gap-6">
					<p class="p-sm">
						{{ package.file.createdAt | date: 'MMM dd, yyyy h:mm a' }}
					</p>
					<ui-anchor
						data-intercom-target="sync-mortgage-package-fax-receipt"
						*ngIf="
							package.displayStatus !== STATUSES.SENDING &&
							package.faxReceipt?.url
						"
						(click)="openPDF(package, 'faxReceipt')"
						>View Receipt</ui-anchor
					>
				</div>
				<div class="col-span-3 p-4 p-sm">
					<ui-status [status]="package.displayStatus"></ui-status>
				</div>
			</div>
		</ng-container>
		<ng-template #noPackages>
			<div class="h-full w-full flex items-center justify-center">
				<div class="flex items-center justify-center py-12 gap-12">
					<img
						class="max-w-40"
						src="/assets/images/undraw/undraw_no_data_04825A.svg"
					/>
					<div class="p text-sm max-w-[300px]">
						Looks like you haven't sent any packages to the lender yet. Go to
						the "Send to Lender" tab to get started.
					</div>
				</div>
			</div>
		</ng-template>
	</div>
</div>
